import React from 'react'
import MediaQueries from 'react-responsive'

export const Desktop = (props) => <MediaQueries {...props} minWidth={768} />
export const Mobile = (props) => <MediaQueries {...props} maxWidth={767} />

const renderComponent = (elementOrComponent, props) =>
  React.isValidElement(elementOrComponent)
    ? elementOrComponent
    : React.createElement(elementOrComponent, props)

const Responsive = ({mobile, desktop, ...props}) => {
  return (
    <>
      {desktop && <Desktop>{renderComponent(desktop, props)}</Desktop>}
      {mobile && <Mobile>{renderComponent(mobile, props)}</Mobile>}
    </>
  )
}

export default Responsive
